import Help from '../loggedin';

export default function PublicHelp() {
  return <Help publicMode />;
}
